/* global axios */
import ApiClient from './ApiClient';

class AiReportsAPI extends ApiClient {
  constructor() {
    super('reports/ai_overview', { accountScoped: true });
  }

  getOverview({ since, until } = {}) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new AiReportsAPI();
